import { render, staticRenderFns } from "./UserFormPage.vue?vue&type=template&id=57bfacde&scoped=true&"
import script from "./UserFormPage.vue?vue&type=script&lang=js&"
export * from "./UserFormPage.vue?vue&type=script&lang=js&"
import style0 from "./UserFormPage.vue?vue&type=style&index=0&id=57bfacde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bfacde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VContainer,VForm,VIcon,VList,VListItem,VListItemContent,VListItemTitle})
